module.exports = __webpack_public_path__ + "assets/img/ru-ec69385a.png";